import React from "react";
import classes from "./MatchGridLayout.module.css";

const MatchGridLayout = ({ children }) => {
  return <div className={classes.matches_container}>{children}</div>;
};

export default MatchGridLayout;
